/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import "moment-timezone";
import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import EDIT from "../../assets/image/EDIT.svg";
import deleteSvg from "../../assets/image/deleteSvg.svg";
import { ClearFormSetFutios } from "../../redux/actions/adminAction";
import ReusableTable from "../UserInformation/ReusableTable";
import CommonewModel from "../commonModel/commonModel";
import DeleteConfirmModal from "./DeleteConfirmModal";
const RecipientManagement = () => {
  const { websocket } = useContext(WebSocketContext);
  const { recipientList, search, listStatus } = useSelector(
    (state) => state.adminReducers
  );
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [showModalNew, setShowModalNew] = useState({
    open: false,
    title: "",
    modalType: "",
    Data: {},
  });
  const [removeModal, setRemoveModal] = useState({
    open: false,
    machine: null,
  });
  const handleRemove = (machine) => {
    setRemoveModal({ open: true, machine });
  };
  const closeRemoveModal = () => {
    setRemoveModal({ open: false, machine: null });
  };
  const confirmRemove = () => {
    const payload = {
      transmit: "single",
      url: "recipient_delete",
      request: {
        recipient_id: removeModal?.machine?.id,
      },
    };
    wsSend_request(websocket, payload);
    setRemoveModal({ open: false, machine: null });
    callUserList();
  };

  const currentFunction = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (currentPage < 1) return;
    setCurrentPage(currentPage);
  }, [currentPage]);

  useEffect(() => {
    callUserList();
  }, [websocket, currentPage, search, listStatus]);

  useEffect(() => {
    callUserList();
  }, []);

  function callUserList() {
    const payload = {
      transmit: "single",
      url: "user_list",
      request: {
        status: "",
        user_type: "recipient",
        limit: "20",
        page_no: search ? 1 : currentPage,
        search: search ? search : "",
        order_by: "-updated_at",
      },
    };
    wsSend_request(websocket, payload);
    dispatch(ClearFormSetFutios({ url: "", action: "" }))
  }
  function handleSwitchChange(id, isChecked) {
    let param = {
      transmit: "single",
      url: "user_status_update",
      request: {
        status: isChecked,
        user_id: id,
      },
    };
    wsSend_request(websocket, param);
  }
  const headers = [
    { name: "Sr.No", key: "sr_no" },
    { name: "Recipient Name", key: "Recipient_Name" },
    { name: "Recipient Login Id", key: "Recipient_Account_Name" },
    { name: "Recipient Email", key: "email" },
    { name: "Recipient Machine Name", key: "Recipient_Machine_Name" },
    { name: "Machine ID", key: "Machine_ID" },
    { name: "Recipient Account Status", key: "Recipient_Account_Status" },
    { name: "Action", key: "Action" },
  ];
  const LIMIT = 20;
  const renderRow = (user, index, visibleColumns) => {
    const serialNumber = (currentPage - 1) * LIMIT + index + 1;
    return (
      <React.Fragment key={user.id}>
        <tr className="user-management-table-detail">
          {visibleColumns?.includes("sr_no") && <td>{serialNumber}</td>}
          {visibleColumns?.includes("Recipient_Name") && (
            <td>{user?.username}</td>
          )}
          {visibleColumns?.includes("Recipient_Account_Name") && (
            <td>{user?.recipient_account_name}</td>
          )}
          {visibleColumns?.includes("email") && <td>{user?.email}</td>}
          {visibleColumns?.includes("Recipient_Machine_Name") && (
            <td>{user?.machine_list_with_recipient ? user?.machine_list_with_recipient?.map(item => item.machineName).join(', ') : "-"}</td>
          )}
          {visibleColumns?.includes("Machine_ID") && (
            <td>
              {user?.machine?.length > 0 ? user?.machine?.join(", ") : "-"}
            </td>
          )}

          {visibleColumns?.includes("Recipient_Account_Status") && (
            <td>
              <Form.Check
                type="switch"
                id={`switch-${user.id}`}
                defaultChecked={user.is_active}
                onChange={(e) => handleSwitchChange(user.id, e.target.checked)}
                className=""
              />
            </td>
          )}
          {visibleColumns?.includes("Action") && (
            <td style={{ cursor: "default" }}>
              <span
                className="detail-icon"
                onClick={() => navigate("/edit-recipient/" + user.id)}
              >
                <img src={EDIT} alt="edit" title="Edit" />
              </span>
              <span
                className="detail-icon"
                onClick={() => handleRemove(user)}
              >
                <img src={deleteSvg} alt="edit" title="Edit" />
              </span>
            </td>
          )}
        </tr>
      </React.Fragment>
    );
  };

  return (
    <>
      <ReusableTable
        headers={headers}
        data={recipientList?.data || []}
        paginationObject={recipientList?.pagination}
        renderRow={renderRow}
        height="150px"
        filters={{
          fromDate: false,
          toDate: false,
          period: false,
          search: true,
          searchPlaceholder:
            "Search by Recipient Name, Recipient Login Id, Email, Recipient Machine Name & Machine Id",
          userSelect: false,
          userOptions: [],
          userActive: false,
          isAdd: true,
          isAddtitle: "Add New Recipient",
          isAddLink: "/add-recipient",

          userOptionsForActive: [
            { label: "All", value: "" },
            { label: "Active", value: "1" },
            { label: "Inactive", value: "0" },
          ],
          export: true,
          reset: false,
        }}
        currentPage={currentPage}
        handlePageChange={currentFunction}
      />
      {showModalNew?.open && (
        <CommonewModel
          setShowModalNew={setShowModalNew}
          showModalNew={showModalNew}
        />
      )}
      {removeModal.open && (
        <DeleteConfirmModal
          open={removeModal.open}
          onClose={closeRemoveModal}
          onConfirm={confirmRemove}
          message="Are you sure you want to Delete this Recipient?"
        />
      )}
    </>
  );
};
export default RecipientManagement;
